import { getStorage, getDownloadURL, ref } from "@firebase/storage"
import { firebaseApp } from "../StApp"
import { UserChatItem } from "../models/api/UserChatItem"

export async function fetchVNoteAudioUrl(chatId:string, voice:string){

    try {
        console.log(`${chatId}/${voice}`)
        const storage = getStorage(firebaseApp)
        return await getDownloadURL(ref(storage, `${chatId}/${voice}`))
    } catch (err) {
        console.error(err)
    }
        
}

export async function fetchVNoteAudioUrlForOverview(chatMsg: UserChatItem){

    try {
        console.log(`${chatMsg.chatId}/${chatMsg.lastChatMsg.voice}`)
        const storage = getStorage(firebaseApp)
        return await getDownloadURL(ref(storage, `${chatMsg.chatId}/${chatMsg.lastChatMsg.voice}`))
    } catch (err) {
        console.error(err)
    }
        
}

export async function fetchProfileImageUrl(uid:string,index:number){

    try {
        //console.log(`${chatMsg.chatId}/${chatMsg.lastChatMsg.voice}`)
        const storage = getStorage(firebaseApp)
        return await getDownloadURL(ref(storage, `users/${uid}/pic${index}`))
    } catch (err) {
        console.error(err)
    }
        
}

export async function fetchVIntroUrl(uid: string) {

    try {
        //console.log(`${chatMsg.chatId}/${chatMsg.lastChatMsg.voice}`)
        const storage = getStorage(firebaseApp)
        const vUrl = await getDownloadURL(ref(storage, `users/${uid}/vIntro`))
        return vUrl
    } catch (err) {
        console.error(err)
    }

}



export function makeId(length: number) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

export function delay(time: number) {
    return new Promise(resolve => setTimeout(resolve, time));
  }
